<div class="container-fluid" [ngClass]="{'height-100-checklist':makeHeightFull}" *ngIf="isSectionVisible">
    <fieldset class="border rounded-3 p-1" [ngClass]="{'height-100-checklist':makeHeightFull}" [class.section-disabled]="isSectionLocked">
        <legend class="float-none w-auto px-1 ml-1 font-size-13">{{'REVIEW_SOL_PM_REQUIREMENTS_TAB.TITLE' |translate}}
            <si-check-box *ngIf="optionalWorkflowCondition" [isReadMode]="false" [isDisabled]="isDisable || isReadOnlyMode"
                [isChecked]="isProjectMgmtRequirementsChecked" (change)="onProjectMgmtRequirementsToggle($event)"></si-check-box>
        </legend>
<div class="row" [formGroup]="pmRequirementForm" trackChanges [appOptionalWorkflow]="optionalWorkflowCondition" [initialExpanded]="true">
    <div class="col-sm-6">
        <div class="row bottomPadding">
            <div class="col-sm-4">
                <mat-label>{{'REVIEW_SOL_PM_REQUIREMENTS_TAB.PROJECT_DURATION' |translate}}</mat-label>
            </div>
            <div class="col-sm-4  mt-3">
                <span class="addPadding">{{pmRequirementForm.get('projectDuration')?.value}} Days</span>
            </div>
        </div>
        <div class="row bottomPadding">
            <div class="col-sm-4" *ngIf="business === constants.BUSINESS_AUTOMATION || business === constants.BUSINESS_ELECTRICAL || business === constants.BUSINESS_MECHANICAL">
                <mat-label>{{'REVIEW_SOL_PM_REQUIREMENTS_TAB.FREQUENCY_OF_PROJECT_MEETINGS' |translate}} </mat-label>
            </div>
            <div class="col-sm-6">
                <app-si-form-field [isReadMode]="isReadOnlyMode" [isDisabled]="isDisable" type="number" [maxlength]="3" formControlName="frequencyOfProjectMeetings" [max]="999" (blur)="resetIfEmpty()"></app-si-form-field>
            </div>
        </div>
        <div class="row bottomPadding">
            <div class="col-sm-4">
                <mat-label>{{'REVIEW_SOL_PM_REQUIREMENTS_TAB.DOCUMENTATION_REQUIREMENTS' |translate}}</mat-label>
            </div>
            <div class="col-sm-6 break-word">
                 <app-si-form-field [isReadMode]="isReadOnlyMode" [isDisabled]="isDisable" formControlName="documentationRequirements"></app-si-form-field>
            </div>
        </div>
        <div class="row bottomPadding">
            <div class="col-sm-4">
                <mat-label>{{'REVIEW_SOL_PM_REQUIREMENTS_TAB.TIME_ESTIMATED_TO_MANAGE_SCHEDULE' |translate}}</mat-label>
            </div>
            <div class="col-sm-6">
                 <mat-radio-group class="radio-group radio-btns" formControlName="timeEstimatedToManageSchedule"  [disabled]="isDisable">
                    <si-radio-button
                        [displayText]="'YES' | translate"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isDisable">
                    </si-radio-button>
                    <si-radio-button
                        [displayText]="'NO' | translate"
                        [isReadMode]="isReadOnlyMode"
                        [isDisabled]="isDisable">
                    </si-radio-button>
                </mat-radio-group>
            </div>
        </div>
        <div class="row bottomPadding">
            <div class="col-sm-4">
                <mat-label>{{'REVIEW_SOL_PM_REQUIREMENTS_TAB.ESTIMATED_PM_HOURS' |translate}}</mat-label>
            </div>
            <div class="col-sm-6">
                 <app-si-form-field [isReadMode]="isReadOnlyMode" [isDisabled]="isDisable" type="number" [maxlength]="3" [max]="168" formControlName="estimatedPmHoursOnJobSite" (blur)="resetEstimatedPmHoursIfEmpty()"></app-si-form-field>
            </div>
        </div>
       
    </div>
    </div>
</fieldset>
</div>
<div class="container-fluid" *ngIf="isSectionNotApplicableShow()">
    <fieldset class="border rounded-3 p-1" >
        <legend class="float-none w-auto px-1 ml-1 font-size-13">{{'REVIEW_SOL_PM_REQUIREMENTS_TAB.TITLE' |translate}}</legend>
        <div class="row bottomPadding">
            <div class="col-sm-12">
                <span>{{'REVIEW_SOL_PM_REQUIREMENTS_TAB.SECTION_NOT_APPLICABLE' |translate}}</span>
            </div>
        </div>
    </fieldset>
</div>
<div class="container-fluid customizeText" *ngIf="!isSectionVisible && !makeHeightFull">
    {{'REVIEW_SOL_PM_REQUIREMENTS_TAB.PM_REQUIREMENTS_DATA_NOT_FOUND' |translate}}
</div>

